import { StatCard } from '@skylabs-digital/backoffice-kit';
import { AlertTriangle, Database, Files, Gauge, TrendingUp, Upload } from 'lucide-react';
import type { StorageOverview } from '../../schemas/storage.schema';
import { formatBytes } from '../apps/AppList';

export function StorageKpis({ overview }: { overview: StorageOverview | null }) {
  const busy = overview === null;
  const o = overview;
  const quota = o ? Number(o.totalQuotaBytes) : 0;
  const used = o ? Number(o.totalBytesUsed) : 0;
  const percent = quota > 0 ? Math.floor((used / quota) * 100) : null;
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6">
      <StatCard
        label="Used"
        value={formatBytes(o?.totalBytesUsed)}
        hint={percent !== null ? `${percent}% of ${formatBytes(quota)} quota` : 'no quotas set'}
        icon={<Database />}
        loading={busy}
      />
      <StatCard label="Files" value={o?.totalFiles ?? '—'} icon={<Files />} loading={busy} />
      <StatCard
        label="Added (7d)"
        value={formatBytes(o?.bytesAdded7d)}
        icon={<TrendingUp />}
        loading={busy}
      />
      <StatCard
        label="Added (30d)"
        value={formatBytes(o?.bytesAdded30d)}
        icon={<TrendingUp />}
        loading={busy}
      />
      <StatCard
        label="Pending uploads"
        value={o?.totalPending ?? '—'}
        hint={
          o && o.totalStalePending > 0 ? `${o.totalStalePending} expired, not swept` : undefined
        }
        icon={<Upload />}
        tone={o && o.totalStalePending > 0 ? 'warning' : 'neutral'}
        loading={busy}
      />
      <StatCard
        label="Near quota"
        value={o?.nearQuota.length ?? '—'}
        hint="apps at 80% or more"
        icon={<Gauge />}
        tone={o && o.nearQuota.length > 0 ? 'danger' : 'success'}
        loading={busy}
      />
      {o && o.nearQuota.length > 0 ? (
        <p className="col-span-full flex items-center gap-2 text-sm text-muted-foreground">
          <AlertTriangle className="h-4 w-4 text-destructive" />
          {o.nearQuota.map((a) => `${a.appName} (${a.quotaUsedPercent}%)`).join(', ')}
        </p>
      ) : null}
    </div>
  );
}
